export const cards = [
  {
    id: 1,
    title: "Lorem ipsum dolor",
    type: "fullpage",
    category: "Sea",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/01.jpg",
  },
  {
    id: 2,
    title: "Sit amet consectetur",
    type: "popup",
    category: "Mountain",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/02.jpg",
  },
  {
    id: 3,
    title: "Consectetur adipiscing",
    type: "popup",
    category: "Sea",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/03.jpg",
  },
  {
    id: 4,
    title: "Do eiusmod tempor",
    type: "popup",
    category: "Mountain",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/04.jpg",
  },
  {
    id: 5,
    title: "Labore et dolore magna",
    type: "popup",
    category: "Sea",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/05.jpg",
  },
  {
    id: 6,
    title: "Ut enim ad minim",
    type: "fullpage",
    category: "Sea",
    summary:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit sed do eiusmod tempor.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",

    img: "https://www.aroundweb.it/davidebalice.dev/animated-ui/06.jpg",
  },
];
